import { render, staticRenderFns } from "./EmailTemplateForm.vue?vue&type=template&id=3e280e0a&scoped=true"
import script from "./EmailTemplateForm.vue?vue&type=script&lang=ts"
export * from "./EmailTemplateForm.vue?vue&type=script&lang=ts"
import style0 from "./EmailTemplateForm.vue?vue&type=style&index=0&id=3e280e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e280e0a",
  null
  
)

export default component.exports